// src/components/Sections/PricingSection/PricingSection.jsx

import React from 'react';
import './PricingSection.scss';

const foundingFeatures = [
  'Access to the member platform at launch',
  'Simple scoring, GPS, stats, and golf history',
  'Groups, season standings, Tour Series, and leaderboards',
  'Member community and opportunities to participate in club experiences',
  'Founding Member recognition',
  'Founding rate locked in while membership remains active'
];

export default function PricingSection() {
  return (
    <section
      id="pricing"
      className="membership-offer section-v2 section-v2--dark"
    >
      <div
        className="membership-offer__pattern"
        aria-hidden="true"
      >
        THE TOUR · FOUNDING MEMBER · THE TOUR · FOUNDING MEMBER
      </div>

      <div className="container membership-offer__layout">
        {/* =====================================================
            LEFT SIDE
            ===================================================== */}

        <div className="membership-offer__intro">
          <p className="eyebrow eyebrow--light">
            Founding Membership
          </p>

          <h2>
            Join the club
            <span>from the beginning.</span>
          </h2>

          <p className="membership-offer__intro-copy">
            The founding class will help shape the club in the GTA:
            its culture, competition, and real-world member experiences.
            Request your place on the founding list ahead of the 2027 season.
          </p>

          <div className="membership-offer__price">
            <strong>
              $39.99
            </strong>

            <div className="membership-offer__price-meta">
              <span>
                CAD / year
              </span>

              <small>
                Founding rate
              </small>
            </div>
          </div>

          <p className="membership-offer__regular">
            Regular membership will be $64.99/year
            after the founding launch.
          </p>

          <div className="membership-offer__rate-lock">
            <span
              className="membership-offer__rate-lock-icon"
              aria-hidden="true"
            >
              ✓
            </span>

            <p>
              Founding Members keep the
              <strong> $39.99 annual rate </strong>
              while their membership remains active.
            </p>
          </div>
        </div>

        {/* =====================================================
            RIGHT SIDE
            ===================================================== */}

        <div className="membership-offer__visual">
          <article className="membership-card">
            {/* TOP */}

            <div className="membership-card__top">
              <div className="membership-card__brand">
                <div
                  className="membership-card__monogram"
                  aria-hidden="true"
                >
                  TG
                </div>

                <div>
                  <span>
                    The Tour Golfers
                  </span>

                  <small>
                    Founding Membership · 2027
                  </small>
                </div>
              </div>

              <span className="membership-card__badge">
                Founding Member
              </span>
            </div>

            {/* BODY */}

            <div className="membership-card__body">
              <p className="membership-card__kicker">
                Your membership
              </p>

              <h3>
                More than a scoring subscription.
              </h3>

              <p className="membership-card__description">
                One member identity connecting practical golf tools,
                shared rounds, Tour Series competition, and the community
                growing around public golf.
              </p>

              <div className="membership-card__features">
                {foundingFeatures.map((feature) => (
                  <div
                    className="membership-card__feature"
                    key={feature}
                  >
                    <span aria-hidden="true">
                      ✓
                    </span>

                    <p>
                      {feature}
                    </p>
                  </div>
                ))}
              </div>

              <a
                href="#contact"
                className="button button--dark membership-card__cta"
              >
                Request Founding Membership
              </a>

              <p className="membership-card__fineprint">
                This button submits an inquiry; it does not take payment.
                Green fees, tournament entries, simulator bookings, ticketed
                events, and other experiences may have separate costs.
                Partner benefits and event formats are subject to launch plans.
              </p>
            </div>

            {/* FOOTER */}

            <div className="membership-card__footer">
              <span>
                GTA · Founding Class 2027
              </span>

              <strong>
                A Country Club Without Walls.
              </strong>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}